import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["date_created", "date_modified", "edit_permission", "grantor_id", "grantor_public_id", "document_id", "job_id"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import pick from 'lodash/pick';
import moment from 'moment';
import { observable, computed, reaction } from 'mobx';
import { Model } from 'libx';
var DocumentAccess = (_class = /*#__PURE__*/function (_Model) {
  function DocumentAccess() {
    var _this;
    _classCallCheck(this, DocumentAccess);
    _this = _callSuper(this, DocumentAccess, arguments);
    // When the access changes, refetch the document
    // so we get the latest `can_edit` value.
    _initializerDefineProperty(_this, "dateCreated", _descriptor, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor2, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor3, _this);
    _initializerDefineProperty(_this, "grantorId", _descriptor4, _this);
    _initializerDefineProperty(_this, "grantorPublicId", _descriptor5, _this);
    _initializerDefineProperty(_this, "editPermission", _descriptor6, _this);
    _initializerDefineProperty(_this, "documentId", _descriptor7, _this);
    _this._refreshDocument = _this._refreshDocument.bind(_this);
    // Refetch the document when edit permissions change
    reaction(function () {
      return _this.editPermission;
    }, _this._refreshDocument, {
      delay: 500
    });
    // Fetch the member once the document has been linked.
    reaction(function () {
      return [_this.document, _this.grantorId, _this.grantorPublicId];
    }, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        doc = _ref2[0],
        grantorId = _ref2[1],
        grantorPublicId = _ref2[2];
      return doc && _this.rootStore.memberStore.setAndFetch({
        workspace_id: doc.workspaceId,
        user_id: grantorId,
        user_public_id: grantorPublicId
      });
    }, {
      fireImmediately: true
    });
    return _this;
  }
  _inherits(DocumentAccess, _Model);
  return _createClass(DocumentAccess, [{
    key: "job",
    get: function get() {
      return this.rootStore.jobStore.jobs.get(this.jobId);
    }
  }, {
    key: "document",
    get: function get() {
      return this.rootStore.documentStore.documents.get(this.documentId);
    }
  }, {
    key: "grantor",
    get: function get() {
      if (!this.document) {
        return null;
      }
      return this.rootStore.memberStore.forWorkspaceAndUserPublicId(this.document.workspaceId, this.grantorPublicId);
    }
  }, {
    key: "parse",
    value: function parse(_ref3) {
      var date_created = _ref3.date_created,
        date_modified = _ref3.date_modified,
        edit_permission = _ref3.edit_permission,
        grantor_id = _ref3.grantor_id,
        grantor_public_id = _ref3.grantor_public_id,
        document_id = _ref3.document_id,
        job_id = _ref3.job_id,
        json = _objectWithoutProperties(_ref3, _excluded);
      return _objectSpread(_objectSpread({}, pick(json, ['id', 'type'])), {}, {
        jobId: job_id,
        documentId: document_id,
        grantorId: grantor_id,
        grantorPublicId: grantor_public_id,
        editPermission: edit_permission,
        dateCreated: moment(date_created || this.dateCreated),
        dateModified: moment(date_modified || this.dateModified)
      });
    }
  }, {
    key: "_refreshDocument",
    value: function _refreshDocument() {
      if (this.documentId) {
        this.rootStore.documentStore.fetchDocument(this.documentId);
      }
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "grantorId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "grantorPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "editPermission", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "documentId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "job", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "job"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "document", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "document"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "grantor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "grantor"), _class.prototype), _class);
export { DocumentAccess as default };
//# sourceMappingURL=DocumentAccess.js.map
